<template>
  <v-lightbox :is-authenticated="true">
    <template v-slot:trigger>
      <div class="flex">
        <a
          @click="show = true"
          class="button button--gray max-lg:!h-[38px] max-lg:!min-h-[38px] max-lg:!w-[38px] max-lg:!p-0 xl:max-2xl:!h-[38px] xl:max-2xl:!min-h-[38px] xl:max-2xl:!w-[38px] xl:max-2xl:!p-0"
        >
            <v-icon icon="edit"></v-icon>
            <span class="hidden lg:inline xl:hidden 2xl:inline">
                <label class="">Uredite iskanje</label>
            </span>
        </a>
      </div>
    </template>
    <template v-slot:head>
      <v-icon icon="edit" class="mr-2.5 text-black-78"></v-icon>
      Uredite iskanje
    </template>
    <template v-slot:content>
        <div class="space-y-4 mb-12">
            <v-accordion
                :title="countryPlaceholder.label"
                icon="map-pin"
                ref="accordionCountry"
            >
                <template v-slot:content>
                    <div class="px-4 pb-8">
                        <div class="grid grid-cols-2 gap-x-5 gap-y-2.5">
                            <div
                                v-for="(option, index) in countryOptions"
                                v-bind:key="'country' + index"
                            >
                                <v-form-radio
                                    name="country"
                                    :id="'country' + index"
                                    :label="option.label"
                                    :value="option.value"
                                    v-model="countryValue"
                                    :fixed-height="true"
                                    @change="fetchRegions()"
                                >
                                    <template v-slot:icon>
                                        <v-icon :icon="'loupe-world'" size="5" class="mr-2"></v-icon>
                                    </template>
                                </v-form-radio>
                            </div>
                        </div>
                    </div>
                </template>
            </v-accordion>

            <v-accordion
                    :title="regionPlaceholder"
                    :icon="'map-pin'"
                    ref="accordionRegion"
                >
                    <template v-slot:content>
                        <div class="px-4 pb-8">
                            <div class="grid grid-cols-2 gap-x-5 gap-y-2.5">
                                <div
                                    v-for="(option, index) in regions"
                                    v-bind:key="'region' + index"
                                >
                                    <v-form-radio
                                        name="region"
                                        :id="'region' + index"
                                        :label="option.region"
                                        :value="option.region"
                                        v-model="regionValue"
                                        :fixed-height="true"
                                        @change="locationOption = null, fetchLocations()"
                                    >
                                        <template v-slot:icon>
                                            <v-icon :icon="'loupe-world'" size="5" class="mr-2"></v-icon>
                                        </template>
                                    </v-form-radio>
                                </div>
                            </div>
                        </div>
                    </template>
                </v-accordion>


            <v-accordion
                :title="locationPlaceholder.custom_label"
                icon="map-pin"
                ref="accordionLocation"
            >
                <template v-slot:content>
                    <div class="px-4 pb-8">
                        <div
                            class="relative flex items-center rounded-full border border-gray bg-white"
                            :class="{'border-salmon': locationError != null}"
                        >
                            <label
                                for="location"
                                class="absolute left-0 top-0 z-10 flex h-full w-full cursor-pointer items-center rounded-full px-8 py-4 font-medium text-black-50 hover:bg-green-10 md:px-10"
                                v-if="
                                    !hideLocationLabel &&
                                    locationOption === null
                                "
                                @click="openLocation"
                            >
                                <div
                                    class="overflow-hidden text-ellipsis whitespace-nowrap text-sm"
                                >
                                    <span class="text-black-78"
                                        >Lokacija:</span
                                    >
                                    mesto, ulica, poštna št.
                                </div>
                            </label>
                            <v-select
                                class="w-full font-medium text-black-78"
                                :options="locations"
                                placeholder=""
                                v-model="locationOption"
                                label="custom_label"
                                @open="onOpen"
                                @search:focus="onFocus"
                                @search:blur="onBlur"
                                @search="fetchLocations()"
                                ref="location"
                                id="location"
                            >
                                <template v-slot:no-options>
                                    Za ta iskalni niz ni zadetkov.
                                </template>
                            </v-select>
                            <input
                                type="hidden"
                                name="location"
                                :value="
                                    locationOption == null
                                        ? ''
                                        : locationOption.value
                                "
                            />
                        </div>
                        <p v-if="locationError != null" v-text="locationError" class="text-salmon text-sm mt-2"></p>
                    </div>
                </template>
            </v-accordion>

            <v-accordion
                :title="rentOrBuyPlaceholder.label"
                :icon="rentOrBuyPlaceholder.icon"
                ref="accordionRentOrBuy"
            >
                <template v-slot:content>
                    <div class="px-4 pb-8">
                        <div
                            class="grid grid-cols-2 gap-x-5 gap-y-2.5"
                        >
                            <div
                                v-for="(
                                    option, index
                                ) in rentOrBuyOptions"
                                v-bind:key="
                                    'rent_or_buy' + index
                                "
                            >
                                <v-form-radio
                                    name="rent_or_buy"
                                    :id="'rent_or_buy_' + index"
                                    :label="option.label"
                                    :value="option.value"
                                    v-model="rentOrBuyValue"
                                    :fixed-height="true"
                                >
                                    <template v-slot:icon>
                                        <v-icon
                                            :icon="option.icon"
                                            size="5"
                                            class="mr-2"
                                        ></v-icon>
                                    </template>
                                </v-form-radio>
                            </div>
                        </div>
                    </div>
                </template>
            </v-accordion>

            <v-accordion
                :title="realestateTypePlaceholder.label"
                :icon="realestateTypePlaceholder.icon"
                ref="accordionRealestateType"
            >
                <template v-slot:content>
                    <div class="px-4 pb-8">
                        <div
                            class="grid grid-cols-2 gap-x-5 gap-y-2.5"
                        >
                            <div
                                v-for="(
                                    option, index
                                ) in realestateTypeOptions"
                                v-bind:key="
                                    'realestate_property_type' +
                                    index
                                "
                            >
                                <v-form-radio
                                    name="realestate_property_type"
                                    :id="
                                        'realestate_property_type_' +
                                        index
                                    "
                                    :label="option.label"
                                    :value="option.value"
                                    v-model="
                                        realestateTypeValue
                                    "
                                    :fixed-height="true"
                                >
                                    <template v-slot:icon>
                                        <v-icon
                                            :icon="option.icon"
                                            size="5"
                                            class="mr-2 flex-shrink-0"
                                        ></v-icon>
                                    </template>
                                </v-form-radio>
                            </div>
                        </div>
                    </div>
                </template>
            </v-accordion>

            <v-accordion
                :title="pricePlaceholder.label"
                icon="euro"
                ref="accordionPrice"
            >
                <template v-slot:content>
                    <div class="px-4 pb-8">
                        <div class="flex items-center gap-3">
                            <div>
                                <v-form-input
                                    id="price_from"
                                    label="od"
                                    type="number"
                                    :value="minPrice"
                                    v-model="minPrice"
                                    append-text="€"
                                ></v-form-input>
                            </div>

                            <div>
                                <v-form-input
                                    id="price_to"
                                    label="do"
                                    type="number"
                                    :value="maxPrice"
                                    v-model="maxPrice"
                                    append-text="€"
                                ></v-form-input>
                            </div>
                        </div>

                        <div
                            class="mt-5 flex justify-center gap-5"
                        >
                            <!-- -->

                            <button
                                class="button"
                                @click="confirmPrice"
                            >
                                <v-icon icon="check"></v-icon>
                                Potrdi
                            </button>
                        </div>
                    </div>
                </template>
            </v-accordion>

            <v-form-input
                id="radius"
                label="Okrožje (km)"
                type="number"
                required="required"
                name="radius"
                :value="radius"
                v-model="radius"
            ></v-form-input>
        </div>
    </template>
    <template v-slot:foot>
        <template v-if="submitEnabled">
            <a class="flex button" @click="editSearch()">
                <v-icon icon="edit"></v-icon>
                Shranite spremembe
            </a>
        </template>
        <template v-else>
            <a class="flex button button--gray cursor-not-allowed" @click="event.preventDefault()">
                <v-icon icon="edit"></v-icon>
                Shranite spremembe
            </a>
        </template>

    </template>
  </v-lightbox>
</template>

<script>
import debounce from "lodash/debounce";

export default {
  props: {
    currentCountry: {
        type: String,
        required: true,
    },
    currentRegion: {
        type: String,
        required: true,
    },
    currentSearchRadius: {
        type: Number,
        required: true,
    },
    currentLocationData: {
        type: Object,
        required: true,
    },
    searchEditRoute: {
      type: String,
      required: true,
    },
    searchCriteriaId: {
      type: Number,
      required: true,
    },
    currentLocation: {
      type: String,
      default: null,
    },
    rentOrBuy: {
      type: String,
      default: null,
    },
    propertyType: {
      type: String,
      default: null,
    },
    priceFrom: {
      type: [String, Number],
      default: null,
    },
    priceTo: {
      type: [String, Number],
      default: null,
    },
    enums: {
        type: Object,
        required: true,
    },
    i18n: {
        type: Object,
        required: true,
    },
  },
  data() {
    return {
        submitting: false,
        searchEditSuccessfully: false,
        locations: [],
        rentOrBuyOptions: [],
        realestateTypeOptions: [],
        openedAccordion: null,
        locationError: null,
        hideLocationLabel: false,
        regions: [],
        regionValue: this.currentRegion,
        locationOption: this.currentLocationData ?? null,
        countryOptions: [],
        rentOrBuyValue: "miete",
        realestateTypeValue: "wohnung",
        minPrice: "",
        maxPrice: "",
        countryValue: this.currentCountry,
        radius: this.currentSearchRadius
    };
  },
  watch: {
        countryValue: {
            handler: function (val, oldVal) {
                if (val !== "") {
                    this.toggleAccordion("accordionCountry");
                    this.toggleAccordion("accordionRegion");
                    this.locationOption = null
                    this.regionValue = ""
                }
            },
        },
        regionValue: {
            handler: function (val, oldVal) {
                if (val !== "") {
                    this.toggleAccordion("accordionRegion");
                    this.toggleAccordion("accordionLocation");
                }
            },
        },
        locationOption: {
            handler: function (val, oldVal) {
                if (val !== null && val) {
                    this.locationError = null;
                    this.toggleAccordion("accordionLocation");
                    this.toggleAccordion("accordionRentOrBuy");
                    this.regionValue = val.region
                }
            },
        },
        rentOrBuyValue: {
            handler: function (val, oldVal) {
                if (val !== "") {
                    this.toggleAccordion("accordionRentOrBuy");
                    this.toggleAccordion("accordionRealestateType");
                }
            },
        },
        realestateTypeValue: {
            handler: function (val, oldVal) {
                if (val !== "") {
                    this.toggleAccordion("accordionRealestateType");
                    this.toggleAccordion("accordionPrice");
                }
            },
        },
    },
  mounted() {
    this.fetchLocations(null, this.currentLocationData.region);
    this.fetchRegions();

    this.rentOrBuyOptions = this.parseEnums('vermarktungsart');
    this.realestateTypeOptions = this.parseEnums('objektart');
    this.countryOptions = this.parseEnums('land', ["SVN", "HRV"]);

    if (!this.locationOption || !this.locationOption.custom_label) {
        this.locationOption = null;
    }

    this.rentOrBuyValue = this.rentOrBuy;
    this.realestateTypeValue = this.propertyType;
    this.minPrice = this.priceFrom?.replaceAll(".00", "") ?? "";
    this.maxPrice = this.priceTo?.replaceAll(".00", "") ?? "";
  },

  computed: {
    countryPlaceholder() {
        if (this.countryValue === "") {
            return {
                label: "Izberite državo",
                icon: "map-pin",
            };
        }

        return this.countryOptions.find(
            (option) => option.value === this.countryValue
        );
    },
    regionPlaceholder() {
        if (this.regionValue === "") {
            return "Izberite regijo"
        }

        return this.regionValue
    },
    submitEnabled() {
        if(this.submitting)
            return false;

        if(!this.regionValue)
            return false;

        if(this.rentOrBuyValue == "")
            return false;

        if(this.realestateTypeValue == "")
            return false;

        return true;
    },
    locationPlaceholder() {
        if (!this.locationOption) {
            return {
                custom_label: "Lokacija",
            };
        }
        return this.locationOption;
    },
    rentOrBuyPlaceholder() {
        if (this.rentOrBuyValue === "") {
            return {
                label: "Prodaja ali oddaja",
                icon: "key",
            };
        }

        return this.rentOrBuyOptions.find(
            (option) => option.value === this.rentOrBuyValue
        );
    },
    realestateTypePlaceholder() {
        if (this.realestateTypeValue === "") {
            return {
                label: "Tip nepremičnine",
                icon: "house",
            };
        }

        return this.realestateTypeOptions.find(
            (option) => option.value === this.realestateTypeValue
        );
    },
    pricePlaceholder() {
        if (this.minPrice && !this.maxPrice) {
            return {
                label: `${this.$filters.formatNumber(this.minPrice)} €`,
                icon: "euro",
            };
        }

        if (!this.minPrice && this.maxPrice) {
            return {
                label: `0 - ${this.$filters.formatNumber(this.maxPrice)} €`,
                icon: "euro",
            };
        }

        if (this.minPrice && this.maxPrice) {
            return {
                label: `${this.$filters.formatNumber(
                    this.minPrice
                )} € - ${this.$filters.formatNumber(this.maxPrice)} €`,
                icon: "euro",
            };
        }

        return {
            label: "Cena",
            icon: "euro",
        };
    },
},
  methods: {
    fetchRegions() {
        axios
            .get(this.$route("api.regions"), {params: {country: this.countryValue}})
            .then((response) => {
                const regions = response.data.data;
                this.regions = regions;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    fetchLocations: debounce(async function (value, region) {
        if (value === "" || value === null) {
            this.locations = [];
            return;
        }

        try {
            const response = await axios.get(this.$route("api.locations"), {
                params: {
                    region: (this.regionValue ? this.regionValue :  null),
                    search: value,
                    country: this.countryValue
                },
            });

            let locationsResponse = response.data.data;
            this.locations = locationsResponse.map((location) => {
                return {
                    value: location["code"],
                    custom_label: location["location"],
                    region: location["region"],
                };
            });
        } catch (error) {
            console.log(error);
        } finally {
            // Ensure loading(false) is defined
            // this.loading(false);
        }
    }, 500),
    editSearch() {
      this.submitting = true;
      let data = {
        search_criteria_id: this.searchCriteriaId,
        real_estate_location: this.locationOption?.value ?? null,
        real_estate_type: this.realestateTypeValue, //this.realestate_property_type,
        rent_or_buy: this.rentOrBuyValue, //this.rent_or_buy,
        real_estate_price_from: this.minPrice, //this.price_from,
        real_estate_price_to: this.maxPrice, //this.price_to,
        real_estate_country: this.countryValue,
        real_estate_region: this.regionValue,
        search_radius: this.radius,
      };


      let header = {
        headers: {
          "X-CSRF-TOKEN": this.$csrfToken,
        },
      };

      axios.post(this.searchEditRoute, data, header).then(
        (response) => {
            location.reload();
        },
        (error) => {
          console.log(error);
          this.submitting = false;
        }
      );
    },
    parseEnums(key, limit = []) {
      let specificEnums = []

      Object.values(this.enums).forEach((enumGroup) => {
        if(enumGroup.group == key) {
          Object.keys(enumGroup.values).forEach((enumGroupValueKey) => {
            // Check for limitations (only push allowed values)
            if(limit.length > 0 && !limit.includes(enumGroupValueKey)) {
                return;
            }

            specificEnums.push({
              value: enumGroupValueKey,
              label: enumGroup.values[enumGroupValueKey],
              icon: this.i18n[enumGroupValueKey] ? this.i18n[enumGroupValueKey].icon : '',
            });
          });
        }
      });

      return specificEnums;
    },
    openLocation() {
        // Access the Vue Select instance using the ref
        const selectComponent = this.$refs.location;

        // Check if the Vue Select instance exists and is defined
        if (selectComponent) {
            selectComponent.$refs.search.focus();
        }
    },

    onFocus() {
        this.hideLocationLabel = true;
    },

    onBlur() {
        this.hideLocationLabel = false;
    },

    confirmPrice() {
        this.toggleAccordion("accordionPrice");
    },

    toggleAccordion(ref) {
        this.$refs[ref]?.toggleAccordion();
    },

    openAccordion(ref) {
        this.$refs[ref]?.openAccordion();
    },

    closeAccordion(ref) {
        this.$refs[ref]?.closeAccordion();
    },
  },
};
</script>
